import { MapUtils } from '../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../dto/data-model-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LocalizedString } from '../localized-string.js';

export class FormFieldOption extends DataModel {
  static readonly TYPE_ID: string = '7bdcc35ef46746a6b1c10d567c86abf9';

  private constructor(
    public readonly uniqueId: string,
    public readonly value: LocalizedString,
  ) {
    super();
  }

  get $typeId(): string {
    return FormFieldOption.TYPE_ID;
  }

  static create(args: {
    uniqueId: string,
    value: LocalizedString,
  }): FormFieldOption {
    return new FormFieldOption(args.uniqueId, args.value);
  }

  static fromMap(context: SerializationContext, map: SerializedData): FormFieldOption {
    return new FormFieldOption(
        MapUtils.getString(map, 'uniqueId'),
        context.fromData<LocalizedString>(MapUtils.getRecord(map, 'value')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'value': context.toData(this.value),
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    uniqueId: uniqueId = this.uniqueId,
    value: value = cloneData(this.value),
  }: {
    uniqueId?: string,
    value?: LocalizedString,
  } = {}): this {
    return FormFieldOption.create({
      uniqueId: uniqueId,
      value: value,
    }) as this;
  }

  isSame(other: FormFieldOption): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
      isSameData(other.value, this.value);
  }
}

export class FormFieldOptionBuilder extends DataModelBuilder<FormFieldOption> {
  build(context: SerializationContext, map: SerializedData): FormFieldOption {
    return FormFieldOption.fromMap(context, map);
  }
}
